import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/pageDirector.svg'
import _imports_1 from '@/assets/images/sign.png'


const _withScopeId = n => (_pushScopeId("data-v-01b2251e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "back" }
const _hoisted_2 = { class: "config" }
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = { class: "sidebar_con" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "cont_pounp" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "main" }
const _hoisted_11 = { class: "main_line" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_line_name" }, "签到标题：", -1))
const _hoisted_13 = { class: "main_line" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_line_name" }, "按钮文字：", -1))
const _hoisted_15 = { class: "main_line" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_line_name" }, "活动背景：", -1))

import { message } from 'ant-design-vue';
import { reactive, ref } from 'vue';
import CUpload from '@/components/CUpload.vue';
import { useRoute } from 'vue-router';
import router from '@/router';
import { RollbackOutlined } from '@ant-design/icons-vue';
import http from '@/api/application';
import { FileInfo } from './sign';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfigSign',
  setup(__props) {

const route = useRoute();
const form = reactive({
  name: '',
  font: '',
  image: '',
  loading: false,
});
const fileList = ref();
const handleChange = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    form.image = info.file?.response?.data.url;
  }
  if (info.file.status === 'uploading') {
    form.loading = true;
    return;
  } else {
    form.loading = false;
  }
  if (info.file.status === 'error') {
    message.error('上传失败');
  }
};
const imageDel = () => {
  form.image = '';
};

// 获取活动信息
const getConfig = () => {
  http
    .get_activity_info({ params: { id: route.query.id } })
    .then((res) => {
      const resData = res.data.data;
      form.name = resData.sign_title;
      form.font = resData.button_copy;
      form.image = resData.sign_background_image;
    })
    .catch((err) => message.error(err.data.error));
};
getConfig();

// 保存
const save = () => {
  http
    .set_activity_page({ id: route.query.id, sign_title: form.name, button_copy: form.font, sign_background_image: form.image })
    .then((res) => {
      message.success(res.data.message);
      router.push('/application/signWall');
    })
    .catch((err) => message.error(err.data.error));
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/application/signWall')))
      }, {
        icon: _withCtx(() => [
          _createVNode(_unref(RollbackOutlined))
        ]),
        default: _withCtx(() => [
          _createTextVNode("返回列表 ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (form.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: form.image,
                  alt: ""
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("p", null, _toDisplayString(form.name), 1),
              _createVNode(_component_a_button, {
                type: "primary",
                class: "btn_sign"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(form.font), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_a_input, {
            value: form.name,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.name) = $event)),
            placeholder: "请输入签到标题",
            class: "main_line_in"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_a_input, {
            value: form.font,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.font) = $event)),
            placeholder: "请输入按钮文字",
            class: "main_line_in"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(CUpload, {
            "file-list": fileList.value,
            "handle-change": handleChange,
            loading: form.loading,
            "image-name": form.image,
            "click-stop": imageDel,
            class: "main_line_upload"
          }, null, 8, ["file-list", "loading", "image-name"])
        ]),
        _createVNode(_component_a_button, {
          type: "primary",
          class: "btn_save",
          onClick: save
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存")
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})